// src/ckeditor.js

// Importa a base do editor clássico para estendê-la
import ClassicEditorBase from '@ckeditor/ckeditor5-build-classic';


// Importa o pacote de tradução para Português (Brasil)
import '@ckeditor/ckeditor5-build-classic/build/translations/pt-br';

// Cria uma nova classe para o seu editor customizado
export default class CustomEditor extends ClassicEditorBase {}

// Adiciona o plugin de Fontes à lista de plugins existentes do build clássico
CustomEditor.builtinPlugins = [
    ...ClassicEditorBase.builtinPlugins,
];

// Define a configuração padrão para seu editor
CustomEditor.defaultConfig = {
    // Aqui adicionamos os novos botões de cor na barra de ferramentas
    toolbar: {
        items: [
            'undo',
            'redo',
            'heading',
            '|',
            'bold',
            'italic',
            'link',
            'bulletedList',
            'numberedList',
            '|',
            'outdent',
            'indent',
            '|',
            'blockQuote',
            'insertTable',

        ]
    },
    image: {
        toolbar: ['imageTextAlternative', 'imageStyle:inline', 'imageStyle:block', 'imageStyle:side']
    },
    // E aqui definimos o idioma padrão
    language: 'pt-br',
};